<template>
  <div class="container">
    <!-- 年份选择 -->
    <div class="year-container">
      <div class="year-selector">
        <div class="year-label">选择年度</div>
        <div class="year-picker" @click="showYearPicker = true">
          <span class="year-value">{{ selectedYear }}</span>
          <van-icon name="arrow-down" size="16" color="#999" />
        </div>
      </div>
    </div>

    <!-- 数据统计卡片 -->
    <div class="stats-container">
      <!-- 小区维度卡片 -->
      <div class="stats-row">
        <div class="stats-card bg-1">
          <div class="card-title">小区应缴总额</div>
          <div class="card-value black">{{ formatMoney(xiaoquData.totalAmount) }}</div>
        </div>
        <div class="stats-card bg-2">
          <div class="card-row">
            <div class="card-item">
              <div class="card-title">小区实缴总额</div>
              <div class="card-value black">{{ formatMoney(xiaoquData.paidAmount) }}</div>
            </div>
            <div class="card-item">
              <div class="card-title">实缴率</div>
              <div class="card-value blue">{{ xiaoquData.paidRate }}%</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 本栋维度卡片 -->
      <div class="stats-row">
        <div class="stats-card bg-3">
          <div class="card-title">本栋应缴总额</div>
          <div class="card-value black">{{ formatMoney(bendongData.totalAmount) }}</div>
        </div>
        <div class="stats-card bg-4">
          <div class="card-row">
            <div class="card-item">
              <div class="card-title">本栋实缴总额</div>
              <div class="card-value black">{{ formatMoney(bendongData.paidAmount) }}</div>
            </div>
            <div class="card-item">
              <div class="card-title">实缴率</div>
              <div class="card-value blue">{{ bendongData.paidRate }}%</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 缴费一览图Tab -->
    <div class="custom-tabs">
      <div
        class="custom-tab"
        :class="{ active: activeTab === 'property' }"
        @click="switchTab('property')"
      >
        物业服务费
      </div>
      <div
        class="custom-tab"
        :class="{ active: activeTab === 'agency' }"
        @click="switchTab('agency')"
      >
        代收代交费
      </div>
    </div>

    <!-- 缴费一览图 -->
    <div class="overview-section">
      <div class="overview-header">
        <div class="overview-title">住户缴费一览图</div>
      </div>
      <div class="status-legend">
        <div class="legend-item">
          <div class="legend-circle paid"></div>
          <span>已缴</span>
        </div>
        <div class="legend-item">
          <div class="legend-circle unpaid"></div>
          <span>未缴</span>
        </div>
      </div>
      <van-loading v-if="loading" class="loading" />
      <div v-else-if="currentData.residents.length === 0" class="empty-state">
        <van-icon name="wap-home" size="48" color="#999" />
        <div class="empty-text">暂无住户数据</div>
      </div>
      <div v-else class="residents-grid">
        <div
          class="resident-item"
          :class="resident.status"
          v-for="(resident, index) in currentData.residents"
          :key="index"
        >
          <div class="resident-icon">
            <van-icon name="wap-home" />
          </div>
          <div class="resident-room">{{ resident.room }}</div>
        </div>
      </div>
    </div>

    <!-- 年份选择器 -->
    <van-popup v-model="showYearPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="yearColumns"
        @confirm="onYearConfirm"
        @cancel="showYearPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from '@/utils/request'

export default {
  name: 'SzmxJfqk',
  data() {
    const currentYear = new Date().getFullYear()
    return {
      loading: true,
      activeTab: 'property',
      selectedYear: currentYear,
      showYearPicker: false,
      yearColumns: [currentYear, currentYear - 1, currentYear - 2, currentYear - 3].map(String),
      // 小区数据
      xiaoquData: {
        totalAmount: 0,
        paidAmount: 0,
        paidRate: 0
      },
      // 本栋数据
      bendongData: {
        totalAmount: 0,
        paidAmount: 0,
        paidRate: 0
      },
      // 统计数据(用于住户列表)
      statsData: {
        paidCount: 0,
        unpaidCount: 0,
        houseDetails: []
      }
    }
  },
  computed: {
    currentData() {
      return {
        residents: (this.statsData.houseDetails || []).map(item => ({
          room: item.houseAddress,
          status: item.isPaid ? 'paid' : 'unpaid'
        }))
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        // 费用类型映射
        const feeTypeMap = {
          'property': '1',
          'agency': '2'
        }
        const params = {
          startDate: `${this.selectedYear}-01-01`,
          endDate: `${this.selectedYear}-12-31`,
          feeType: feeTypeMap[this.activeTab] || '1'
        }

        // 调用原接口
        const res = await axios.get('/api/v1/unitJn/stats', { params })

        if (res) {
          // 本栋维度数据
          this.bendongData = {
            totalAmount: res.totalAmount || 0,
            paidAmount: res.paidAmount || 0,
            paidRate: this.formatRate(res.paidRate)
          }

          // 小区维度数据
          this.xiaoquData = {
            totalAmount: res.villageTotalAmount || 0,
            paidAmount: res.villagePaidAmount || 0,
            paidRate: this.formatRate(res.villagePaidRate)
          }

          // 住户详情
          this.statsData = {
            paidCount: res.paidCount || 0,
            unpaidCount: res.unpaidCount || 0,
            houseDetails: res.houseDetails || []
          }
        }
      } catch (error) {
        console.error('加载数据失败:', error)
      }
      this.loading = false
    },

    onYearConfirm(value) {
      this.selectedYear = parseInt(value)
      this.showYearPicker = false
      this.loadData()
    },

    onTabChange() {
      this.loadData()
    },
    switchTab(tab) {
      this.activeTab = tab
      this.loadData()
    },

    formatRate(rate) {
      if (!rate && rate !== 0) return 0
      return Math.round(rate * 100) / 100
    },

    formatMoney(value) {
      if (!value && value !== 0) return '¥0'
      if (value >= 10000) {
        return '¥' + (value / 10000).toFixed(1) + '万'
      }
      return '¥' + value.toLocaleString()
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 16px 0;
}

.year-container {
  background-color: #fff;
  margin: 0 16px 16px 16px;
  border-radius: 12px;
}

.year-selector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}

.year-label {
  font-size: 16px;
  color: #333;
}

.year-picker {
  display: flex;
  align-items: center;
  gap: 4px;
}

.year-value {
  font-size: 16px;
  color: #333;
}

.custom-tabs {
  display: flex;
  gap: 24px;
  padding: 16px;
  background-color: #f5f5f5;
}

.custom-tab {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  padding-bottom: 8px;
  cursor: pointer;
  position: relative;
}

.custom-tab.active {
  color: #3683E1;
}

.custom-tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 29px;
  height: 3px;
  background-color: #3683E1;
  border-radius: 2px;
}

.stats-container {
  background-color: #fff;
  margin: 0 16px 16px;
  border-radius: 12px;
  padding: 4px 0;
}

.stats-row {
  display: flex;
  gap: 12px;
  padding: 12px 16px;
}

.stats-card {
  border-radius: 12px;
  padding: 16px 12px;
}

.stats-card.bg-1 {
  flex: 1;
  background-color: #E5EEFD;
}

.stats-card.bg-2 {
  flex: 2;
  background-color: #EEF4FE;
}

.stats-card.bg-3 {
  flex: 1;
  background-color: #ECFAFC;
}

.stats-card.bg-4 {
  flex: 2;
  background-color: #F6FCFD;
}

.card-row {
  display: flex;
  gap: 16px;
}

.card-item {
  flex: 1;
}

.card-title {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  white-space: nowrap;
}

.card-value {
  font-weight: 700;
  line-height: 26px;
  text-align: left;
  white-space: nowrap;
}

/* 小区维度 - 上行数字颜色 */
.stats-row:first-child .card-value {
  color: #4671C7;
}

/* 本栋维度 - 下行数字颜色 */
.stats-row:last-child .card-value {
  color: #29ADC7;
}

.overview-section {
  background: white;
  padding: 16px;
  margin: 0 16px 20px;
  border-radius: 12px;
}

.overview-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.overview-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  width: 100%;
}

.status-legend {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #666;
}

.legend-circle {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid;
}

.legend-circle.paid {
  border-color: #52c41a;
}

.legend-circle.unpaid {
  border-color: #ff4d4f;
}

.loading {
  text-align: center;
  padding: 32px 16px;
}

.empty-state {
  text-align: center;
  padding: 48px 16px;
  color: #999;
}

.empty-text {
  font-size: 16px;
  margin-top: 16px;
}

.residents-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.resident-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 10px;
  border-radius: 12px;
  min-height: 80px;
}

.resident-item.paid {
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
}

.resident-item.unpaid {
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
}

.resident-icon {
  font-size: 24px;
  margin-bottom: 8px;
}

.resident-item.paid .resident-icon {
  color: #52c41a;
}

.resident-item.unpaid .resident-icon {
  color: #ff4d4f;
}

.resident-room {
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}

.resident-item.paid .resident-room {
  color: #52c41a;
}

.resident-item.unpaid .resident-room {
  color: #ff4d4f;
}
</style>
